import InfoCard from '../../../components/info-card'

export default function VerificationInfo() {
  return (
    <div className='info'>
      <h2>Our verification process</h2>
      <InfoCard>
        <div className='imageContainer flex justifyCenter'>
          <img
            src='/images/verify-info.jpg'
            alt='woman with card and laptop'
            width='1020'
            height='620'
          />
        </div>
        <aside>
          <h3>privauto Keeps You Safe</h3>
          <p>
            privauto is built from the ground up, with your safety in mind. Using our simple
            and quick identity verification process, we can ensure your auto transaction is safe and
            secure.
          </p>
          <p>
            Our identity verification is carried out by{' '}
            <a href='https://Trulioo.com' target='_blank'>
              Trulio.com
            </a>
            , one of the most trusted names in safe and secure identity verification. Your personal
            information is only used for the purposes of verifying your identity and we do not share
            or sell it to any other third parties.
          </p>
          <p>
            For your safety, before selling or buying a vehicle on privauto, all participants
            must be successfully verified!
          </p>
        </aside>
      </InfoCard>

      <style jsx>{`
        h2 {
          margin: 0 0 2.1rem;
          text-align: center;
          font-size: 5.4rem;
        }

        .imageContainer {
          max-width: 101.7rem;
          width: 100%;
          min-height: 62.3rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        aside {
          max-width: 51.3rem;
          padding: 7rem 5.7rem 7rem;
        }

        h3 {
          margin: 0 0 1.4rem;
          line-height: 4.3rem;
          font-size: 3.2rem;
        }

        p {
          line-height: 3rem;
          font-size: 2.2rem;

          & + p {
            margin: 4rem 0 0;
          }
        }

        @media (max-width: 1024px) {
          h2 {
            margin: 0 0 1.3rem;
            font-size: 2rem;
          }

          .imageContainer {
            max-width: 100%;
            min-height: unset;
          }

          aside {
            max-width: 100%;
            padding: 1.9rem 2.6rem 4.1rem;
          }

          h3 {
            margin: 0 0 1.1rem;
            line-height: 2rem;
            font-size: 1.4rem;
          }

          p {
            line-height: unset;
            font-size: 1.4rem;

            & + p {
              margin: 2rem 0 0;
            }
          }
        }
      `}</style>
    </div>
  )
}
